import React, { useState } from 'react';
import { Box } from '@mui/material';

function ReadMoreText({ children, maxChars = 20, allowExpand = true }) {
  const [expanded, setExpanded] = useState(false);

  if (!children || typeof children !== 'string') return children;

  const shouldTruncate = children.length > maxChars;
  const displayText =
    expanded || !shouldTruncate
      ? `${children} `
      : `${children.slice(0, maxChars)}... `;

  return (
    <>
      {displayText}
      {shouldTruncate && allowExpand && (
        <Box
          component="button"
          type="button"
          onClick={() => setExpanded(!expanded)}
          style={{
            background: 'none',
            padding: 0,
            border: 'none',
            textDecoration: 'underline',
            cursor: 'pointer',
          }}
          sx={{ color: 'primary.main' }}>
          {expanded ? 'less' : 'more'}
        </Box>
      )}
    </>
  );
}

export default ReadMoreText;
